{
    "title": "New Transaction",
    "subtitle": "Before making a transfer, please register the recipient information based on the location",
    "input":{
        "counterpartyType": "Select the counterparty type",
        "countryofdestination": "Country of Destination",
        "rail": "Rail"
    },
    "advice":"Transactions to the current country destination are not yet available. We will notify you when they become available."
}